declare global {
  interface Window {
    $zoho: any
  }
}

export function initSalesIQ(language?: string): void {
  const widgetCode = 'c936914766371ce098c6e256bdb92f96e87cce2f97ff290440f94e3d36622ede'

  window.$zoho = window.$zoho || {}
  window.$zoho.salesiq = window.$zoho.salesiq || {
    widgetcode: widgetCode,
    values: {},
    ready: function () {
      window.$zoho.salesiq.floatbutton.visible('hide')

      if (language) {
        window.$zoho.salesiq.language(language)
      }
    }
  }

  if (!document.getElementById('zsiqscript')) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'zsiqscript'
    script.defer = true
    script.src = 'https://salesiq.zoho.eu/widget'

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode?.insertBefore(script, firstScript)
  }

  if (!document.getElementById('zsiqwidget')) {
    const widgetDiv = document.createElement('div')
    widgetDiv.id = 'zsiqwidget'
    document.body.appendChild(widgetDiv)
  }
}

export function showSalesIQButton(): void {
  if (window.$zoho?.salesiq) {
    window.$zoho.salesiq.floatbutton.visible('show')
  }
}

export function hideSalesIQButton(): void {
  if (window.$zoho?.salesiq) {
    window.$zoho.salesiq.floatbutton.visible('hide')
  }
}

export function setSalesIQLanguage(language: string): void {
  if (window.$zoho?.salesiq?.language) {
    window.$zoho.salesiq.language(language)
  }
}

export function setSalesIQVisitorInfo(info: Record<string, any>): void {
  if (window.$zoho?.salesiq?.visitor?.info) {
    window.$zoho.salesiq.visitor.info(info)
  }
}

export function sendMessage(message: string) {
  if (window.$zoho?.salesiq?.chat?.start) {
    window.$zoho.salesiq.visitor.question(message)
    window.$zoho.salesiq.chat.start()
    window.$zoho.salesiq.chat.continue()
  }
}
